import React from 'react';
import { createRoot } from 'react-dom/client';
import { component } from 'picoapp';
import MiniCart from './MiniCart';

export default component((node, ctx) => {
  if (!customElements.get('mini-cart')) {
    customElements.define(
      'mini-cart',
      class extends HTMLElement {
        constructor() {
          super();
        }
        connectedCallback() {
          const props = Object.values(this.attributes).map((attribute) => [attribute.name, attribute.value]);
          const element = <MiniCart ctx={ctx} el={this} {...Object.fromEntries(props)} />;
          const root = createRoot(this);
          root.render(element);
        }
      }
    );
  }
});
